import { getHiddenBrandStatus } from "@/api/liveRequest/login";
import store from '@/store/index'
import { SET_IS_HIDDEN_BRAND } from "@/store/modules/default";
import { SET_CUSTOMER_SERVICE } from "@/store/modules/liveInfo";
export function globalUpdateLabel() {
	return new Promise((resolve, reject) => {
		const defaultLiveCid = store.state.defaultInfo.defaultLiveCid
		getHiddenBrandStatus(defaultLiveCid)
			.then(res => {
				if (res.code !== 200) return;
				const isHiddenBrand = res.data['is_hidden_263'];
				store.commit(`${SET_IS_HIDDEN_BRAND}`, res.data['is_hidden_263']);
				store.commit(`${SET_CUSTOMER_SERVICE}`, res.data['is_customer_service'])
				const configInfo = { claTitle: res.data['cla_title'], favicon: res.data.icon }
				// 创建一个 link 元素
				const faviconLink = document.createElement('link');
				faviconLink.rel = 'icon';
				if (configInfo.favicon) {
					if (configInfo.favicon !== '') {
						faviconLink.href = configInfo.favicon
					} else {
						faviconLink.href = "/cla/faviconOld.ico"
					}
				} else {
					faviconLink.href = "/cla/faviconOld.ico"
				}
				// 找到文档的头部
				const head = document.head || document.getElementsByTagName('head')[0];
				// 添加 link 元素到头部
				head.appendChild(faviconLink);
				if (configInfo.claTitle) {
					if(configInfo.claTitle != '') {
						document.title = configInfo.claTitle
					} else {
						document.title = this.$t('about.263云播')
					}
					
				} else {
					document.title = this.$t('about.263云播')
				}
				document.title = isHiddenBrand ?
					document.title.replace(/263/g, '') :
					document.title
				resolve('success')
			})
			.catch(e => {
				console.error(e)
				reject('error')
			})
	})
}

// export function setDisturbStatus() {
// 	const isNotDisturb = store.state.defaultInfo.isNotDisturb
//
// }
